<template>
  <div
    class="
      max-h-[288px] w-full overflow-y-auto rounded-12 border border-bor-nav bg-elev-panel-bg p-1
      phone:rounded-none phone:border-0 phone:border-b phone:border-bor-nav phone:p-0
    "
    data-testid="chat_footer_mention_list"
    data-test="mention-list"
  >
    <div
      v-for="(option, index) in availableOptions"
      :key="isPickAllOption(option) ? 'all' : option.id"
      class="flex cursor-pointer items-center gap-3 rounded-8 px-2 py-1.5 transition-colors phone:rounded-none"
      :class="index === selectedOptionIndex && !isPickAllOption(option)
        ? 'bg-bg-base-bg3'
        : 'hover:bg-bg-base-bg4'"
      data-testid="chat_footer_mention_list_item"
      data-test="mention-option"
      @mousedown.prevent
      @click="emits('onOptionClick', index)"
    >
      <template v-if="isPickAllOption(option)">
        <div
          class="
            flex size-8 shrink-0 items-center justify-center rounded-full
            border-2 border-white bg-bg-base-bg4 text-fg-base-fg10
          "
        >
          <wui-icon
            :name="option.icon"
            class="h-5! w-5!"
          />
        </div>
        <div class="min-w-0 flex-1 truncate text-body-m-14-20 text-fg-base-fg3">
          <span>{{ option.title }}</span>
          <span class="text-label-r-12-18 text-fg-base-fg10">
            {{ ' ' + option.subtitle }}
          </span>
        </div>
      </template>
      <template v-else>
        <contact-avatar
          class="shrink-0"
          :size="32"
          :contact="option"
        />
        <div class="min-w-0 flex-1 truncate text-body-m-14-20 text-fg-base-fg3">
          {{ option.name }}
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'

import { ContactAvatar } from '@/entities/contact-avatar'

import {
  isPickAllOption,
  type OptionsTuple,
} from '@/shared/composables/use-mention'

defineProps<{
  availableOptions: OptionsTuple
  selectedOptionIndex: number
}>()

const emits = defineEmits<{
  (event: 'onOptionClick', value: number): void
}>()
</script>
